<template>
  <div class="income">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'Main'
}
</script>
